<template>
  <div>
    <div class="import-batch">
      <gj-button type="primary" @click="addProduct">添加</gj-button>
      <gj-button @click="importBatch">导入</gj-button>
    </div>
    <gj-alert style="padding: 16px 0 12px 0;" type="warning" :title="titleMsg" show-icon></gj-alert>
    <el-form ref="form" :model="form">
      <gj-table
        ref="gjTable"
        size="has-picture"
        name="flag"
        :index="false"
        :data="form.items"
        :columns="columns"
        :loading="loading.table"
        :offsetHeight="48"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery">
        <template v-slot:header:purchaseCostTotal>
          <span style="color: red">*&nbsp;</span>总采购成本
        </template>
        <!-- 单个采购成本自定义表头 -->
        <template v-slot:header:purchaseCost>
          <div class="flex justify-between">
            <span class="gj-mr8"><span style="color: red">*&nbsp;</span>单个采购成本</span>
            <BatchCost @confirm="confirmBatch('purchaseCost', $event)"></BatchCost>
          </div>
        </template>
        <template v-slot:header:arrivalCostTotal>
          <span style="color: red">*&nbsp;</span>总到库成本
        </template>
        <!-- 单个到库成本自定义表头 -->
        <template v-slot:header:arrivalCost>
          <div class="flex justify-between">
            <span class="gj-mr8"><span style="color: red">*&nbsp;</span>单个到库成本</span>
            <BatchCost @confirm="confirmBatch('arrivalCost', $event)"></BatchCost>
          </div>
        </template>
        <!-- 总采购成本 -->
        <template v-slot:purchaseCostTotal="{ row, index }">
          <el-form-item
            :prop="`items[${index}].purchaseCostTotal`"
            :rules="[
              { required: true, message: '请输入总采购成本', trigger: ['blur', 'change']},
              $gjReRule(RE.num(4), '最多四位小数的正数'),
            ]">
            <gj-input maxlength="10" v-model="form.items[index].purchaseCostTotal" @input="changeTotal('purchaseCost', row, index, $event)" width="96%">
              <template #prepend>{{ row.purchaseCurrencySymbol }}</template>
            </gj-input>
          </el-form-item>
        </template>
        <!-- 单个采购成本 -->
        <template v-slot:purchaseCost="{ row, index }">
          <el-form-item
            :prop="`items.${index}.purchaseCost`"
            :rules="[
              { required: true, message: '请输入单个采购成本', trigger: ['blur', 'change']},
              $gjReRule(RE.num(4), '最多四位小数的正数'),
            ]">
            <gj-input maxlength="10" v-model="form.items[index].purchaseCost" @input="changeSingle('purchaseCostTotal', row, index, $event)" width="96%">
              <template #prepend>{{ row.purchaseCurrencySymbol }}</template>
            </gj-input>
          </el-form-item>
        </template>
        <!-- 总到库成本 -->
        <template v-slot:arrivalCostTotal="{ row, index }">
          <el-form-item
            :prop="`items[${index}].arrivalCostTotal`"
            :rules="[
              { required: true, message: '请输入总到库成本', trigger: ['blur', 'change'] },
              $gjReRule(RE.num(4), '最多四位小数的正数'),
            ]">
            <gj-input maxlength="10" v-model="form.items[index].arrivalCostTotal" @input="changeTotal('arrivalCost', row, index, $event)" width="96%">
              <template #prepend>{{ row.purchaseCurrencySymbol }}</template>
            </gj-input>
          </el-form-item>
        </template>
        <!-- 单个到库成本 -->
        <template v-slot:arrivalCost="{ row, index }">
          <el-form-item
            :prop="`items.${index}.arrivalCost`"
            :rules="[
              { required: true, message: '请输入单个到库成本', trigger: ['blur', 'change'] },
              $gjReRule(RE.num(4), '最多四位小数的正数'),
            ]">
            <gj-input maxlength="10" v-model="form.items[index].arrivalCost" @input="changeSingle('arrivalCostTotal', row, index, $event)" width="96%">
              <template #prepend>{{ row.purchaseCurrencySymbol }}</template>
            </gj-input>
          </el-form-item>
        </template>
        <!--操作 -->
        <template v-slot:op="{ index }">
          <gj-button type="text" @click="deleteItem(index)">移除</gj-button>
        </template>
      </gj-table>
   </el-form>

    <div class="opt">
      <gj-button @click="cancel">取消</gj-button>
      <gj-button type="primary" :loading="loading.confirm" @click="confirm">确认</gj-button>
    </div>

  </div>
</template>

<script>
import ImportBatch from "./ImportBatch.vue";
import AddProduct from "./add-product.vue";
import BatchCost from "./modal/batch-cost"
import { queryMixin, selectionMixin, formRuleMixin } from "@/minxins";
import { isMeaningful } from "@/utils/common";
import { storageCostBatch } from "@/api/finance";
import BigNumber from 'bignumber.js';
export default {
  name: "ReplacementCost",
  mixins: [ queryMixin, selectionMixin, formRuleMixin],
  components: { BatchCost },
  props: {
    // 选中的list
    selectedRowsMap: {
      default: () => [],
    },
  },
  created() {
    let items = this._.cloneDeep(this.selectedRowsMap);
    for (const iterator of items) {
      if (iterator.purchaseCost == "0E-8") {
        iterator.purchaseCos = "0";
      }
      if (iterator.arrivalCost == "0E-8") {
        iterator.purchaseCos = "0";
      }
      iterator.purchaseCost = this._.round(iterator.purchaseCost, 4);
      iterator.purchaseCostTotal = new BigNumber(iterator.purchaseCost).times(iterator.receiptQuantity).decimalPlaces(4) + '';
      iterator.arrivalCost = this._.round(iterator.arrivalCost, 4);
      iterator.arrivalCostTotal = new BigNumber(iterator.arrivalCost).times(iterator.receiptQuantity).decimalPlaces(4) + '';
    }
    this.form.items = items
  },
  data() {
    return {
      loading: {
        confirm: false,
        table: false,
      },
      titleMsg: "重置成本的目的是直接修改此批次的成本。修改后将会影响财务模块的利润报表与销售模块的利润统计的成本数据，修改后系统将于凌晨自动重算，如需立即生效，请去往对应的模块进行手动重算，重置对批次关联的单据成本数据不生效。",
      form: {
        items: []
      },
      columns: [
        { id: 'warehouseName', fixed: "left", header: '仓库', field: 'warehouseName', minWidth: '120px', default: true },
        { id: 'batchNumber', header: '批次号', field: 'batchNumber', minWidth: '120px', default: true },
        {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '60px', default: true, disabled: true},
        { id: 'msku', header: 'MSKU', field: 'msku', minWidth: '170px', default: true },
        { id: 'marketDate', header: '入库日期(站点时区)', field: 'marketDate', minWidth: '130px', default: true },
        { id: 'relevanceCode', header: '单据号', field: 'relevanceCode', minWidth: '135px', default: true },
        { id: 'shipmentId', header: '货件号', field: 'shipmentId', minWidth: '135px', default: true },
        { id: 'receiptQuantity', header: '数量', align: 'center', field: 'receiptQuantity', minWidth: '100px', default: true },
        { id: 'purchaseCostTotal', header: 'slot:purchaseCostTotal', field: 'slot:purchaseCostTotal', minWidth: '125px', default: true },
        { id: 'purchaseCost', header: 'slot:purchaseCost', field: 'slot:purchaseCost', minWidth: '125px', default: true },
        { id: 'arrivalCostTotal', header: 'slot:arrivalCostTotal', field: 'slot:arrivalCostTotal', minWidth: '125px', default: true },
        { id: 'arrivalCost', header: 'slot:arrivalCost', field: 'slot:arrivalCost', minWidth: '125px', default: true },
        { id: 'op', header: '操作', field: 'slot:op', minWidth: '50px', fixed: "right" },
      ],
      purchaseCostVisible: false,
      purchaseCostBatch: '',
      arrivalCostVisible: false,
      arrivalCostBatch: ''
    };
  },
  methods: {
    // 移除
    deleteItem(index) {
      this.form.items.splice(index, 1);
    },
    // 添加批次
    addProduct() {
      this.$gjCreate(AddProduct, {
        props: {
          excludeId: this.form.items.map(e => e.id)
        },
        on: {
          select: (data) => {
            this.updateItems(data);
          },
        },
      });
    },
    // 导入批次
    importBatch() {
      this.$gjCreate(ImportBatch, {
        props: {
          excludeId: this.form.items.map(e => e.id),
          downParams: this.form.items.map(e => ({
            id: e.id,
            arrivalCost: e.arrivalCost,
            purchaseCost: e.purchaseCost,
          }))
        },
        on: {
          importSuccess: (data) => {
            this.updateItems(data);
          },
          importPartSuccess: (data) => {
            this.updateItems(data);
          },
        },
      });
    },
    // 覆盖数据
    updateItems(data) {
      if (isMeaningful(data)) {
        data.forEach((newItem) => {
          const find = this.form.items.find(
            (oldItem) => newItem.id === oldItem.id
          );
          if (newItem.purchaseCost == "0E-8") {
            newItem.purchaseCos = "0";
          }
          if (newItem.arrivalCost == "0E-8") {
            newItem.purchaseCos = "0";
          }
          if (find) {
            Object.assign(find, newItem);
          } else {
            this.form.items.push(newItem);
          }
        });
      }
    },
    // 批量设置单个采购成本/单个到库成本
    confirmBatch(type, ev) {
      this.form.items.forEach((item, index) => {
        if(ev && !isNaN(Number(ev))) {
          item[type] = this._.round(ev, 4);
          item[type+'Total'] = new BigNumber(ev).times(item.receiptQuantity).decimalPlaces(4) + '';
        } else{
          item[type] = '';
          item[type+'Total'] = '';
        }
      })
    },
    // 修改总采购成本/总到库成本
    changeTotal(type, row, index, ev) {
      if(ev && !isNaN(Number(ev))) {
        this.form.items[index][type] = new BigNumber(ev).div(row.receiptQuantity).decimalPlaces(4) + ''
      } else {
        this.form.items[index][type] = 0
      }
    },
    // 修改单个采购成本/总单个到库成本
    changeSingle(type, row, index, ev) {
      if(ev && !isNaN(Number(ev))) {
        this.form.items[index][type] = new BigNumber(ev).times(row.receiptQuantity).decimalPlaces(4) + ''
      } else {
        this.form.items[index][type] = 0
      }
    },
    // 取消
    cancel() {
      this.$emit("cancel")
    },
    // 确定
    confirm() {
      this.loading.confirm = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.storageCostBatch();
        } else {
          this.$gjMessage.error("请完善数据");
          this.loading.confirm = false
          return false;
        }
      });
    },
    // 重置成本
    storageCostBatch() {
      let params = this.form.items.reduce((arr, item) => {
        arr.push({
          id: item.id,
          purchaseCost: item.purchaseCost,
          arrivalCost: item.arrivalCost,
        });
        return arr;
      }, []);
      storageCostBatch(params).then(res => {
         this.$gjMessage.success("重置成功")
         this.$emit("cancel");
      }).complete(()=>{ this.loading.confirm = false });
    },
  },
};
</script>

<style scoped lang="scss">
.import-batch {
  padding: 16px 0 0;
}
// /deep/.el-alert--warning {
//   margin: 12px 0;
//   padding: 12px 20px;
//   font-size: 12px;
//   background: #EDF7FF;
//   border-radius: 2px;
//   border: 1px solid #9CCCFF;
//   color: #333333;
//   .el-alert__icon.el-icon-warning {
//     color: #1F6EEF;
//   }
// }
/deep/.vxe-table--main-wrapper {
  // border: 1px solid #ddd;
}
/deep/.vxe-table--body {
  .vxe-body--row {
    .vxe-body--column {
      height: 54px !important;
      .el-form-item {
        margin: 8px 0 10px;
        position: relative;
      }
      .el-form-item__error {
        position: absolute;
        top: auto;
        bottom: -13px;
        left: 0;
        white-space: initial;
      }
    }
  }
}


.opt {
  padding-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
